import React from 'react';
import styled, { keyframes } from 'styled-components';
import {observer} from "mobx-react";

const SpinnerAnimation = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerBox = styled.div`
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: ${props => props.theme.colors.dark};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${SpinnerAnimation} 1s linear infinite;
`;

export const SpinnerComponent: React.FC<{className?: string}> = observer((props) => {
    return <SpinnerBox className={props.className}/>;
});

